import Link from "next/link";
import React from "react";
import { CPagesPath } from "shared/models/const/pages-path";
import { useTranslations } from "next-intl";
import useGetPersistParams from "custom-hooks/useGetPersintParamas.hook";
import {
  Box,
  Paper,
  List,
  ListItem,
  useMediaQuery,
  useTheme,
  Grid,
  Typography as TypographyMui,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Button from "@components/Button";
import Typography from "@components/Typography";
import WsSectionTitle from "@components/a1-refactor/typography/WsSectionTitle";

const ProjectsWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 0,
  width: "100%",
  height: "calc(100vh - 73px)",
}));

const ContentPicture = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundImage: "url(/images/v2/pic/image-01.jpeg)",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  transform: "rotateY(180deg)",
  position: "relative",
  zIndex: 1,
}));

const ProjectDetails = styled("div")(({ theme }) => ({
  width: "48%",
  position: "absolute",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  zIndex: 2,
  right: 0,
  bottom: 0,
  backgroundColor: "var(--color-brand-cream-primary)",
  borderRadius: "50px 0 0 0",
  padding: "2rem 3rem",
  boxShadow: "none",
  [theme.breakpoints.down("lg")]: {
    width: "60%",
    padding: "2.5rem 3rem",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    borderRadius: 0,
    padding: "2rem 3rem",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    minHeight: "calc((100vh - 73px) / 3)",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "2rem 1rem",
    minHeight: "calc((100vh - 73px) / 3)",
  },
  [theme.breakpoints.down("xs")]: {
    padding: "2rem 0.5rem",
  },
}));

const LinkContentBox = styled(Box)(({ theme }) => ({}));

function ProyectHomeSection() {
  const translation = useTranslations("home.projects");
  const referer = useGetPersistParams({
    useConque: "&",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const benefits = [
    translation("benefitsOne"),
    translation("benefitsTwo"),
    translation("benefitsThree"),
    translation("benefitsFour"),
    translation("benefitsFive"),
  ];
  return (
    <ProjectsWrapper>
      <ContentPicture />
      <ProjectDetails>
        <Grid container mb={4}>
          <Grid container item xs={12}>
            <Grid
              item
              xs={12}
              mb={{
                xs: 0,
                md: -0.5,
              }}
            >
              <WsSectionTitle title={translation("title")} />
            </Grid>

            <Grid item xs={12}>
              <Subtitle>{translation("subtitle")}</Subtitle>
            </Grid>
          </Grid>

          <Grid
            container
            item
            xs={12}
            sx={{
              marginTop: "1rem",
              paddingLeft: {
                md: "0",
              },
            }}
            pl={2}
            component={"ul"}
          >
            {benefits.map((benefit, index) => (
              <Grid item xs={12} key={index} component={"li"}>
                <Typography
                  sx={{
                    color: "var(--color-text-black)",
                    fontSize: 14,
                    fontWeight: 400,
                    listStyle: "disc",
                    listStylePosition: "inside",
                    textAlign: {
                      xs: "left",
                    },
                  }}
                >
                  {benefit}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <LinkContentBox>
          <Link
            href={
              CPagesPath.es.project +
              "?businessTypes=sale&typeProperty[]=project" +
              referer
            }
            passHref
          >
            <Button
              component="a"
              variant="contained"
              bg="--color-brand-red-tertiary"
            >
              {translation("seeProject")}
            </Button>
          </Link>
        </LinkContentBox>
      </ProjectDetails>
    </ProjectsWrapper>
  );
}

export default ProyectHomeSection;

const Title = styled(TypographyMui)(({ theme }) => ({
  color: "var(--color-text-black)",
  fontSize: 40,
  fontWeight: "bold",
  [theme.breakpoints.down("md")]: {
    fontSize: "24px",
  },
}));
const Subtitle = styled(TypographyMui)(({ theme }) => ({
  color: "var(--color-text-black)",
  fontSize: "20.8px",
  marginTop: 0,
  fontWeight: 400,
  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
  },
}));
